require("../sass/style.scss");
require("../fonts/fontello/css/fontello.css");
import 'plyr/dist/plyr.css'; //plyr styles

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");

require("./custom/header.es6");
require("./custom/anchors-general.es6");

(function ($) {

    if ($(".section-scrollTrigger").length > 0) {
        require("./custom/general-scroll-trigger.es6");
    }

    if ($(".section-video-with-popup").length > 0) {
        require("./vendor/modal.js");
        require("./page_builder/section_video_with_popup.es6");
    }

    if ($(".section-our-leaders").length > 0) {
        require("./page_builder/section_our_leaders.es6");
    }

    if ($(".section-vaad-faq").length > 0) {
        require("./page_builder/section_vaad_faq.es6");
    }

    if ($(".section-intro-session-recording").length > 0) {
        require("./vendor/modal.js");
        require("./page_builder/section_intro_session_recording.es6");
    }

    if ($(".section-vaad-form").length > 0) {
        require("./page_builder/section_vaad_form.es6");
    }


})(jQuery);